import { useAuth } from "@/contexts/AuthContext";

export const ROLE_RANK = { viewer: 0, gestor: 1, admin: 2, superadmin: 3 };

export function roleAtLeast(role, min) {
  return (ROLE_RANK[role] ?? -1) >= (ROLE_RANK[min] ?? 99);
}

/**
 * Hook returning role booleans for the current user.
 * Usage:
 *   const { canEdit, canManageOrg, isViewer } = useRole();
 */
export function useRole() {
  const { user } = useAuth();
  const role = user?.role || "viewer";
  return {
    role,
    isSuperadmin: role === "superadmin",
    isAdmin: roleAtLeast(role, "admin"),
    isGestorOrAbove: roleAtLeast(role, "gestor"),
    isViewer: role === "viewer",
    canEdit: roleAtLeast(role, "gestor"),
    canManageOrg: roleAtLeast(role, "admin"),
  };
}

export const ROLE_LABELS = {
  superadmin: "Superadmin",
  admin: "Admin",
  gestor: "Gestor",
  viewer: "Viewer",
};

export const ROLE_DESCRIPTIONS = {
  admin: "Gere tudo na agência: settings, branding, utilizadores e operações.",
  gestor: "Gere eventos, promotores, clientes e operações. Sem acesso a settings críticos.",
  viewer: "Acesso apenas leitura a dashboards e dados operacionais.",
};
